module.exports = __webpack_public_path__ + "static/media/Hover6.3036f919.svg";